import React, { useEffect, useState } from 'react';
import { getRopa } from '../../services/apis';
import { Box, Button, Chip, Grid, Paper, Stack, Typography } from '@mui/material';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import AddIcon from '@mui/icons-material/Add';
import { FormCrearRopa } from './FormCrearRopa';

export const Ropa = () => {
    const [ropa, setRopa] = useState([]);
    const [open, setOpen] = useState(false);

    const cargarRopa = async () => {
        try {
            const response = await getRopa();

            if (response.success) {
                setRopa(response.data);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        cargarRopa();
    }, []);

    return (
        <Box className="clothes-shell">
            <Paper elevation={0} className="clothes-header">
                <Box className="clothes-header-copy">
                    <Typography className="clothes-eyebrow">
                        Samarretes
                    </Typography>
                    <Typography variant="h4" className="clothes-title">
                        Roba registrada
                    </Typography>
                </Box>

                <Stack direction="row" className="clothes-toolbar">
                    <Chip icon={<CheckroomIcon />} label={`${ropa.length} peces`} className="clothes-stat-chip" />
                    <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
                        Afegir
                    </Button>
                </Stack>
            </Paper>

            <Grid container spacing={2} className="clothes-grid">
                {ropa.map((rp) => (
                    <Grid key={rp.id} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                        <Paper elevation={0} className="clothes-card">
                            <Box className="clothes-color-panel" style={{ backgroundColor: rp.color }}>
                                <CheckroomIcon className="clothes-color-icon" />
                            </Box>
                            <Box className="clothes-card-body">
                                <Typography variant="h6" className="clothes-card-title" title={rp.nombre}>
                                    {rp.nombre}
                                </Typography>
                                <Box className="clothes-color-row">
                                    <span className="clothes-color-dot" style={{ backgroundColor: rp.color }} />
                                    <Typography className="clothes-color-code">
                                        {rp.color}
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            <FormCrearRopa open={open} setOpen={setOpen} setRopa={setRopa} />
        </Box>
    );
};
